import instance from '@connection/instance';
import instanceBlob from '@connection/instanceBlob';

const unsetDefaultHeader = () => {
  instance.defaults.headers.common.Authorization = undefined;
  instanceBlob.defaults.headers.common.Authorization = undefined;
};

export default unsetDefaultHeader;
